import {
  a as e,
  b as t,
  c as o
} from "./chunk-BVHSVHOK.js";

// src/node.ts
import { isatty as s } from "tty";
var r = process.env.FORCE_TTY !== void 0 || s(1);
function n() {
  return t(r);
}
function a() {
  return o(r);
}
var u = o(r);
export {
  a as createColors,
  u as default,
  e as getDefaultColors,
  n as isSupported
};
